/* istanbul ignore file */

import { Project } from './project';
import { SelectableField } from './selectable-field';

export class ProjectFieldGroup {
    fields: SelectableField[] = [];
    hasLoadError = false;
    isExpanded = false;
    project?: Project;
}
